var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 10.689V12.2561C10.5308 12.0902 10.026 12 9.5 12C7.01472 12 5 14.0147 5 16.5H3.5C3.5 13.1863 6.18629 10.5 9.5 10.5C10.018 10.5 10.5206 10.5656 11 10.689ZM9.5 9.75C7.01375 9.75 5 7.73625 5 5.25C5 2.76375 7.01375 0.75 9.5 0.75C11.9862 0.75 14 2.76375 14 5.25C14 7.73625 11.9862 9.75 9.5 9.75ZM9.5 8.25C11.1575 8.25 12.5 6.9075 12.5 5.25C12.5 3.5925 11.1575 2.25 9.5 2.25C7.8425 2.25 6.5 3.5925 6.5 5.25C6.5 6.9075 7.8425 8.25 9.5 8.25ZM14 12.75V10.5H15.5V12.75H17.75V14.25H15.5V16.5H14V14.25H11.75V12.75H14Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add-icon.342b25d04dc75ac65a6c8602d0f469e3.svg";
export { ForwardRef as ReactComponent };